import { Button as MaterialButton } from '@mui/material';
import React from 'react';
import styles from './styles';
import { withStyles } from '@mui/styles';

interface Props {
  color: 'primary' | 'inherit';
  variant: 'contained' | 'outlined' | 'text';
  className?: string;
  title?: string;
  onClick?(event: any): void;
  disabled?: boolean;
  classes?: any;
  type?: 'reset' | 'submit' | 'button' | undefined;
}

export function Button(props: Props) {
  const { variant, color, title, classes, onClick, disabled, className, type } = props;
  // const classes = useStyles();
  const propsButton = {
    onClick,
    disabled,
    className,
  };
  return (
    <MaterialButton
      {...propsButton}
      sx={styles}
      classes={{
        text: "text",
      }}
      color={color}
      type={type || 'button'}
      variant={variant}
      className={color === 'primary' ? "primaryButton" : "button"}
    >
      {title}
    </MaterialButton>
  );
}

export const ButtonComponent = Button;

export default Button
